import { getNewArrivalsDate } from "../../utils/new-arrivals";
import { waitForLoaderToHide } from "../utils/scene.utils";
import { getState, getGenericData } from "../../vue/utils/aframe.utils";
import { isCreditCardProduct } from "../../vue/utils/isCreditCardProduct";
import { addVueComponent, removeVueComponent } from "../utils/vue.utils";
import creditCardFooter from "../../vue/components/credit-card-footer.component.vue";
import customercareModal from "../../vue/components/customer-care-modal.component.vue";
import downloadapkModal from "../../vue/components/download-apk-modal.component.vue";
import {
  checkIfRestrictedSubDomain,
  config,
} from "../../vue/helpers/domain-config";
import {
  PRODUCT_ACADEMIA_VR,
  PRODUCT_XR_ACADEMY,
} from "../../vue/helpers/page-constants";
import { getDomainTheme } from "../../vue/utils/domains-theme";
import { getDomainConfigValue } from "../../utils/domain-config";
import { replaceText } from "../../vue/helpers/domain-text-config";
import {
  hasPlayAndWinLink,
  hasPlayNowLink,
  hasWorldCupQuizLink,
} from "../../utils/quiz";
import { hasSeenIntro, setHasSeenIntro } from "../utils/session-storage.utils";
import unsubcribeBtn from "../../vue/components/unsub-btn.component.vue";
import AppShortcutsDockComponent from "../../vue/components/app-shortcuts-dock.component.vue";
import ChatgptComponent from "../../vue/components/chatgpt.component.vue";

AFRAME.registerComponent("main-menu-scene-controller", {
  events: {
    sceneEnter: async function (e) {
      const isRtl = getState().selectedLanguage.rtl;
      this.elVue = document.querySelector("#vue");
      const productTheme = getDomainTheme(config.productName);

      const rotationDate = this.el.querySelector(".new-arrivals-button .rotation-date");
      rotationDate.setAttribute("app-text", { value: "" });
      getNewArrivalsDate().then((value) => {
        rotationDate.setAttribute("app-text", { value });
      });

      this.el.sceneEl.emit("clearBackLink");
      await waitForLoaderToHide();

      const playIntro =
        e.detail.firstScene &&
        !getState().debug &&
        !getState().cardboardMode &&
        !hasSeenIntro() &&
        !getDomainConfigValue("skipIntro");

      if (playIntro) {
        this.el.sceneEl.emit("playIntro");
      } else {
        this.el.sceneEl.emit("activateLookCamera", {
          animate: true,
          width: 12,
          height:
            getDomainConfigValue("showFootballContent") ||
            getDomainConfigValue("showWorldCupContent")
              ? 10
              : 7,
          staticIfMobile: true,
          zoomIn: true,
        });

        setTimeout(() => {
          this.animateButtons(true);
        }, 1000);
      }

      const { homeCenterImage, homeCategories, newArrivalsText } = await getGenericData();
      this.el.querySelector(".new-arrivals-button .title").setAttribute("app-text", {
        value: newArrivalsText,
      });

      this.el
        .querySelector(".cultural-heritage-history .title")
        .setAttribute("app-text", {
          value: homeCategories.culturalHeritageHistory,
          fontSize: isRtl ? "0.24" : "0.21",
        });
      this.el.querySelector(".art .title").setAttribute("app-text", {
        value: homeCategories.art,
        fontSize: isRtl ? "0.24" : "0.21",
      });
      this.el.querySelector(".archaeology .title").setAttribute("app-text", {
        value: homeCategories.archaeology,
        fontSize: isRtl ? "0.24" : "0.21",
      });

      this.el
        .querySelector(".kingdom-of-living-things .title")
        .setAttribute("app-text", {
          value: homeCategories.kingdomOfLivingThings,
          fontSize: isRtl ? "0.24" : "0.21",
        });

      this.el.querySelector(".human-body .title").setAttribute("app-text", {
        value: homeCategories.humanBody,
        fontSize: isRtl ? "0.24" : "0.21",
      });
      this.el.querySelector(".space-science .title").setAttribute("app-text", {
        value: homeCategories.spaceScience,
        fontSize: isRtl ? "0.24" : "0.21",
      });

      // const xPosition = isRtl ? 1 : -1;
      this.el
        .querySelector(".main-menu-center-image-title")
        .setAttribute("position", { x: 0, y: 1.35, z: 0.1 });
      this.el
        .querySelector(".main-menu-center-image-content-primary")
        .setAttribute("position", { x: 0, y: 1.1, z: 0.1 });
      // this.el
      //   .querySelector(".main-menu-center-image-content-secondary")
      //   .setAttribute("position", { x: 0, y: 0.7, z: 0.1 });

      this.el
        .querySelector(".main-menu-center-image-title")
        .setAttribute("app-text", {
          // align: isRtl ? "right" : "left",
          // anchor: isRtl ? "right" : "left",
          // fontSize: isRtl ? "0.16" : "0.14",
          fontSize: "0.11",
          value: replaceText(homeCenterImage.title).toUpperCase(),
          maxWidth: 1.8,
        });

      this.el
        .querySelector(".main-menu-center-image-content-primary")
        .setAttribute("app-text", {
          // align: isRtl ? "right" : "left",
          // anchor: isRtl ? "right" : "left",
          fontSize: "0.15",
          value: homeCenterImage.content,
          maxWidth: 1.8,
        });

      if (
        !hasPlayNowLink() &&
        !hasPlayAndWinLink() &&
        !hasWorldCupQuizLink()
      ) {
        const playAndWin = this.el.querySelector(
          '[navigate-to-app="play-and-win"]'
        );
        const quiz = this.el.querySelector('[navigate-to-app="quiz"]');

        quiz.parentElement.setAttribute(
          "position",
          playAndWin.parentElement.getAttribute("position")
        );
      }

      if (!hasPlayAndWinLink()) {
        const playAndWin = this.el.querySelector(
          '[navigate-to-app="play-and-win"]'
        );
        if (playAndWin && playAndWin.parentEl) {
          playAndWin.removeFromParent();
        }
      }

      if (!hasPlayNowLink()) {
        const playNow = this.el.querySelector('[navigate-to-app="play-now"]');
        if (playNow && playNow.parentEl) {
          playNow.removeFromParent();
        }
      }

      if (!hasWorldCupQuizLink()) {
        const worldCupQuiz = this.el.querySelector(
          '[navigate-to-app="world-cup-quiz"]'
        );
        if (worldCupQuiz && worldCupQuiz.parentEl) {
          worldCupQuiz.removeFromParent();
        }
      }

      this.el
        .querySelector(".main-menu-center-image-content-image-bg")
        .setAttribute("animation", {
          delay: playIntro ? 10250 : 0,
          property: "scale",
          from: "1 1 1",
          to: "2 2 2",
          dir: "normal",
          dur: 600,
          loop: false,
        });

      this.el
        .querySelector(".main-menu-center-image-content-image-bg")
        .setAttribute("animation__2", {
          delay: playIntro ? 10250 : 0,
          property: "material.opacity",
          from: 0,
          to: 1,
          dir: "normal",
          dur: 600,
          loop: false,
        });

      this.el
        .querySelector(".main-menu-center-image-content-image-bg")
        .setAttribute("animation__3", {
          delay: playIntro ? 10250 : 0,
          property: "position",
          from: "0 0 -.1",
          to: "0 0 .1",
          dir: "normal",
          dur: 600,
          loop: false,
        });

      this.el
        .querySelector(".main-menu-center-image-content-image-front")
        .setAttribute("animation", {
          delay: playIntro ? 10000 : 0,
          property: "scale",
          from: "1 1 1",
          to: "2 2 2",
          dir: "normal",
          dur: 600,
          loop: false,
        });
      this.el
        .querySelector(".main-menu-center-image-content-image-front")
        .setAttribute("animation__2", {
          delay: playIntro ? 10000 : 0,
          property: "material.opacity",
          from: 0,
          to: 1,
          dir: "normal",
          dur: 600,
          loop: false,
        });
      this.el
        .querySelector(".main-menu-center-image-content-image-front")
        .setAttribute("animation__3", {
          delay: playIntro ? 10000 : 0,
          property: "position",
          from: "0 0 -.1",
          to: "0 0 .11",
          dir: "normal",
          dur: 600,
          loop: false,
        });

      this.el
        .querySelector(".main-menu-center-button-quiz .title")
        .setAttribute("app-text", {
          fontSize: ".17",
          value: homeCenterImage.startquiz,
          maxWidth: 1.2,
          elipsize: true,
        });

      // this.el
      //   .querySelector(".main-menu-center-button-quiz")
      //   .setAttribute("disabled", getSubdomain() === "localhost");
      if (
        config.productName === PRODUCT_XR_ACADEMY &&
        config.subdomain === "my"
      ) {
        console.log("enter");
        this.vueFooter = addVueComponent(customercareModal);
        this.elVue.classList.add("style-for-credit-card");
      }
      if (
        config.productName === PRODUCT_XR_ACADEMY &&
        (config.subdomain === "fr" || config.subdomain === "ch")
      ) {
        this.vueFooter = addVueComponent(downloadapkModal);
        this.elVue.classList.add("style-for-credit-card");
      }
      if (isCreditCardProduct) {
        this.vueFooter = addVueComponent(creditCardFooter);
        this.elVue.classList.add("style-for-credit-card");
      }
      if (productTheme.unsubscribe_button) {
        this.vueUnsub = addVueComponent(unsubcribeBtn);
      }
      this.el
        .querySelector(".disable-quizz-main-menu-center-image-title")
        .setAttribute("app-text", {
          fontSize: "0.11",
          value: replaceText(homeCenterImage.title).toUpperCase(),
          maxWidth: 1.8,
        });

      const mainMenuBgImage = getDomainTheme(config.productName);
      const bgImageUrl = mainMenuBgImage ? mainMenuBgImage.mainMenuBgImage : "";
      if (bgImageUrl) {
        this.el
          .querySelector(".background")
          .setAttribute("load-asset", "src", bgImageUrl);
      }

      if (!getDomainConfigValue("showFootballContent")) {
        const footballBtn = this.el.querySelector(".football-content-button");
        if (footballBtn && footballBtn.parentEl) {
          footballBtn.removeFromParent();
        }
      }

      if (!getDomainConfigValue("showWorldCupContent")) {
        const worldCupBtn = this.el.querySelector(".worldcup-content-button");
        if (worldCupBtn && worldCupBtn.parentEl) {
          worldCupBtn.removeFromParent();
        }
      }

      if (getDomainConfigValue("appShortcutsDock")) {
        this.appShortcutsDoc = addVueComponent(AppShortcutsDockComponent);
      }
      if (getDomainConfigValue("chatBot")) {
        this.chatbotComponent = addVueComponent(ChatgptComponent);
      }
    },

    sceneExiting: function () {
      this.animateButtons(false);
      if (this.vueFooter) {
        removeVueComponent(this.vueFooter);
        this.elVue.classList.remove("style-for-credit-card");
      }
      [this.vueUnsub, this.appShortcutsDoc, this.chatbotComponent]
        .filter(Boolean)
        .forEach(removeVueComponent);
    },
  },

  animateButtons: function (active) {
    let delay = 0;

    Array.from(this.el.querySelectorAll(".main-menu-button")).forEach(
      (menuButton) => {
        const from = active ? 180 : 0;
        const to = active ? 360 : 180;

        menuButton.setAttribute("rotation", `0 ${from} 0`);
        menuButton.setAttribute("animation", {
          delay,
          easing: "linear",
          property: "object3D.rotation.y",
          from,
          to,
        });

        delay += 100;
      }
    );
  },
});
